import { NotificationListPage } from "@/features/notifications/view/NotificationList/NotificationListPage";

export const AndyNotificationsPage = () => {
  return <NotificationListPage type="notification" title="The Andy App updates on your account" />;
};
